export default (state = {}, action = {}) => {
  switch (action.type) {
    case 'FORECAST_USER_SET':
      return action.payload;
    case 'FORECAST_USER_CLEAR':
      return {};
    default:
      return state;
  }
};
